
import axios from '../../axios';

const CrmActions = {
    updateUserAction : async function(productId, batchId=null, action="1", productType=1) {
        await axios.put(`crm/course-page/visit/`, {
            product_id : productId,
            product_type: productType,
            batch_id : batchId,
            page_url: window.location.href,
            http_referer: document.referrer,
        }).then(res => {
            
        }).catch(err => {
            console.log(err.response);
        })
    }
}

export default CrmActions;